import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';
import { Flex } from '@klarna/mp-ui';

import { DecimalCurrency } from 'moet-core';

const GlobalPricingFootnote = ({ price }) => (
  <Flex style={{ paddingLeft: '1em' }}>
    <Typography textToken="text-style/text/paragraphs/tiny/regular">
      <Message path="products-fe.components.global_prices_dialog.foot_notes.global_price" />
      <DecimalCurrency value={price.transactionFee} currency={price.currencyCode} />
    </Typography>
  </Flex>
);

GlobalPricingFootnote.propTypes = {
  price: PropTypes.object.isRequired,
};

export default GlobalPricingFootnote;
